var map = {
	"./ico_australia.png": "5476",
	"./ico_canada.png": "a765",
	"./ico_indonesia.png": "d65e",
	"./ico_malaysia.png": "e766",
	"./ico_mexico.png": "b594",
	"./ico_myanmar.png": "4a47",
	"./ico_newzealand.png": "7876",
	"./ico_scotland.png": "e28b",
	"./ico_singapore.png": "0fe6",
	"./ico_thailand.png": "e551",
	"./ico_uk.png": "fe14",
	"./ico_usa.png": "d154",
	"./ico_vietnam.png": "da0a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4774";